import { createTableSortLabelFn } from "./columnsfunctions";
import Link from "@amzn/awsui-components-react/polaris/link";
import StatusIndicator from "@amzn/awsui-components-react/polaris/status-indicator";
import Box from "@amzn/awsui-components-react/polaris/box";

const rawColumns = [
  {
    id: "createDate",
    header: "Uploaded",
    cell: (item) => item.createDate,
    sortingField: "createDate",
    // minWidth: 100,
  },
  {
    // minWidth: "10",
    id: "name",
    header: "Name",
    cell: (item) => item.name,
    // sortingField: "name",
    minWidth: 100,
  },
  {
    id: "filename",
    header: "File name",
    cell: (item) => item.filename,
    // sortingField: "filename",
    minWidth: 100,
  },
  {
    id: "statusMessage",
    header: "Status",
    //3 statuses catered for thus far: in-progress, error and success
    cell: (item) =>
      item.statusType ? (
        <StatusIndicator type={item.statusType}>
          {item.statusMessage}
        </StatusIndicator>
      ) : (
        <StatusIndicator>{item.statusMessage}</StatusIndicator>
      ),
    // sortingField: "statusMessage",
    minWidth: 100,
  },
  {
    id: "translationStatus",
    header: "Translation Status",
    cell: (item) => {
      if (
        !item.translationStatus ||
        item.translationStatus === "NOT_REQUESTED"
      ) {
        return <StatusIndicator type="stopped">Not Requested</StatusIndicator>;
      }
      switch (item.translationStatus) {
        case "PENDING":
          return <StatusIndicator type="pending">Pending</StatusIndicator>;
        case "Processing":
          return <StatusIndicator type="pending">Processing</StatusIndicator>;
        case "IN_PROGRESS":
          return <StatusIndicator type="pending">In Progress</StatusIndicator>;
        case "COMPLETED":
          return <StatusIndicator type="success">Completed</StatusIndicator>;
        case "INCOMPLETE":
          return <StatusIndicator type="error">Incomplete</StatusIndicator>;
        case "FAILED":
          return <StatusIndicator type="error">Failed</StatusIndicator>;
        default:
          return <StatusIndicator>{item.translationStatus}</StatusIndicator>;
      }
    },
    minWidth: 120,
  },
  {
    id: "srt",
    header: "SRT",
    // cell: item => item.srt ? <Button href={item.srt} variant="link">SRT</Button> : 'N/A',
    cell: (item) =>
      item.srt ? (
        <a href={item.srt} target="_blank" rel="noreferrer">
          SRT
        </a>
      ) : (
        "N/A"
      ),
    minWidth: 100,
  },
  {
    id: "vtt",
    header: "VTT",
    cell: (item) =>
      item.vtt ? (
        <a href={item.vtt} target="_blank" rel="noreferrer">
          VTT
        </a>
      ) : (
        "N/A"
      ),
    minWidth: 100,
  },
  {
    id: "docx",
    header: "Word Doc",
    cell: (item) =>
      item.docx ? (
        <a href={item.docx} target="_blank" rel="noreferrer">
          Word Doc
        </a>
      ) : (
        "N/A"
      ),
    minWidth: 100,
  },
  {
    id: "translatedSrt",
    header: "Translated SRT",
    cell: (item) =>
      item.translatedSrt ? (
        <a href={item.translatedSrt} target="_blank" rel="noreferrer">
          Translated SRT
        </a>
      ) : (
        "N/A"
      ),
    minWidth: 120,
  },
  {
    id: "translatedVtt",
    header: "Translated VTT",
    cell: (item) =>
      item.translatedVtt ? (
        <a href={item.translatedVtt} target="_blank" rel="noreferrer">
          Translated VTT
        </a>
      ) : (
        "N/A"
      ),
    minWidth: 120,
  },
  {
    id: "translatedDocx",
    header: "Translated Word Doc",
    cell: (item) =>
      item.translatedDocx ? (
        <a href={item.translatedDocx} target="_blank" rel="noreferrer">
          Translated Word Doc
        </a>
      ) : (
        "N/A"
      ),
    minWidth: 150,
  },
  {
    id: "languageToDisplay",
    header: "Language",
    cell: (item) => item.languageToDisplay,
    // sortingField: "languageToDisplay",
    minWidth: 100,
  },
  {
    id: "translationLanguageToDisplay",
    header: "Translation Language",
    cell: (item) =>
      item.translationLanguageToDisplay &&
      item.translationLanguageToDisplay !== "None (No Translation)"
        ? item.translationLanguageToDisplay
        : "None",
    minWidth: 120,
  },
  {
    id: "description",
    header: "Description",
    cell: (item) => item.description,
    minWidth: 100,
  },
  {
    id: "costSavings",
    header: "Cost Savings",
    cell: (item) =>
      item.costSavings == 0 ? (
        <Box textAlign="center" fontSize="body-m">
          N/A
        </Box>
      ) : (
        <Box
          textAlign="center"
          color="text-status-success"
          fontSize="body-m"
          fontWeight="bold"
        >
          ${Number(item.costSavings).toFixed(2)}
        </Box>
      ),
    // sortingField: "costSavings",
    minWidth: 100,
  },
];

export const COLUMN_DEFINITIONS = rawColumns.map((column) => ({
  ...column,
  ariaLabel: createTableSortLabelFn(column),
}));
